import type { PlaeeOrderResponseDto } from '@/lib/models';

/**
 * Cash tied up in a set of resting orders, in dollars — the "Resting $X" chip
 * (PRD §6.1). Only BUY orders reserve cash (a resting sell locks contracts,
 * not dollars); each contributes its unfilled remainder × limit price (¢).
 */
export function restingCashDollars(orders: Pick<PlaeeOrderResponseDto, 'action' | 'leavesQty' | 'price'>[]): number {
  return orders.reduce((sum, o) => (o.action === 'buy' ? sum + (o.leavesQty * o.price) / 100 : sum), 0);
}
